import React, {useState, useEffect} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import TreeMap from "../../../components/TreeMap";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {cloudHealthAlerts} from "../../../utils/gridColumnDefs/cloud/cloudHealthAlerts";
import {Card, Col, Row} from "reactstrap";

export default function CloudHealthAlerts({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();
    const [gridData, setGridData] = useState();

    const [data] = useDataWithRoute(`/api/v6/report/enterprise_cloud_health_detail_proc?client_id=${client.clientId}&period_id=${periodId}`);

    useEffect(() => {
        let gData = data?.recordsets?.[0]?.map(d => {
            d['serviceNowInstance'] = client.serviceNowInstance;
            d['serviceNowUser'] = client.serviceNowUser;
            d['serviceNowPassword'] = client.serviceNowPassword;
            return d;
        });
        setGridData(gData);
    }, [data, client]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Cloud Health Alerts</VsiH4>
        <VsiBubble>
            <Grid addStyle
                //   filterChanged={filterChanged}
                  data={gridData}
                  columnDefs={cloudHealthAlerts}/>
        </VsiBubble>
    </Card>
}
